export default __webpack_public_path__ + "static/Inter-700-latin-da941c3b739014ce2d8e8776689f46a9.woff2";